<div class="nav">
    <ul class="nav nav-pills nav-fill fixed-bottom px-1 py-2 d-flex justify-content-center">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 0" (click)="navigateToTab(0)">
                <i class="bi bi-cart-fill"></i>
                <span class="tab-title"> {{ 'coupon.all_coupon' | translate }} </span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 1" (click)="navigateToTab(1)">
                <i class="bi bi-star-fill"></i>
                <span class="tab-title"> {{ 'coupon.weekly_top_coupons' | translate }} </span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 2" (click)="navigateToTab(2)">
                <i class="bi bi-images"></i>
                <span class="tab-title"> {{ 'coupon.carousel_coupons' | translate }} </span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 3" (click)="navigateToTab(3)">
                <i class="fas fa-table"></i>
                <span class="tab-title"> {{ 'user_coupon.purchased_pivot' | translate }} </span>
            </a>
        </li>
    </ul>
</div>
<div class="container" (swipe)="onSwipe($event)">
    <div *ngIf="activeTab === 0">
        <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
            <app-filter-coupon-list [filter]="allFilter"></app-filter-coupon-list>
        </div>
    </div>
    <div *ngIf="activeTab === 1">
        <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
            <app-filter-coupon-list [filter]="weeklyTopFilter"></app-filter-coupon-list>
        </div>
    </div>
    <div *ngIf="activeTab === 2">
        <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
            <app-filter-coupon-list [filter]="carouselFilter"></app-filter-coupon-list>
        </div>
    </div>
    <div *ngIf="activeTab === 3">
        <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
            <app-user-coupon-report></app-user-coupon-report>
        </div>
    </div>
</div>
